import { Box, FormControl, Button, NativeSelect, InputLabel } from '@mui/material'
import { OperatorsSubListI } from '../../interfaces/filters'
import { useAppSelector } from '../../hooks/hooks'
import { useChangeOperatorMutation } from '../../store/appealsFromAppAPI'
import { useState, ChangeEvent } from 'react'


interface MultipleChoiceProps {                                     // множественный выбор заявок для массового назначения одному оператору
  selectedAppeals: { [id: string]: boolean }
  clearSelectedAppeals: () => void
  listSubUsers: OperatorsSubListI[]
}

const MultipleChoice = ({ selectedAppeals, clearSelectedAppeals, listSubUsers }: MultipleChoiceProps) => {
  const { role } = useAppSelector(state => state.user)
  const [changeOperator] = useChangeOperatorMutation()
  const [selectedOperator, setSelectedOperator] = useState<string>('0')
  const [isLoading, setIsLoading] = useState(false)                                       // Состояние загрузки


  const handleOperatorChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedOperator(e.target.value)
  };

  const onAppoint = async () => {
    if (!selectedOperator || selectedOperator === '0') {
      alert('Выберите исполнителя')
      return
    }
    const selectedIds = Object.entries(selectedAppeals)               //  свойство Object.entries превращает объект в массив [id, checked]  (формируется массив selectedIds)
      .filter(([_, checked]) => checked)
      .map(([id]) => id)

    if (selectedIds.length === 0) {
      alert('Выберите хотя бы одно обращение')
      return
    }
    setIsLoading(true)

    console.log(selectedIds)

    try {
      const results = await Promise.allSettled( 
        selectedIds.map(id =>
          // changeOperator({ id, operator_id: selectedOperator, typeUser: role }).unwrap()
          changeOperator({ id, operator_id: selectedOperator, typeList: 'listSubUsers' }).unwrap()            // множественный выбор может назначать только ВОДОСБЫТ
        )
      )
      // const dataToSave = {
      //   appeals: selectedIds,
      //   operator: selectedOperator,
      // }
      // localStorage.setItem('selectedAppealsWithOperator', JSON.stringify(dataToSave))
      clearSelectedAppeals()
      setSelectedOperator('0')
    } catch (error) {
      alert('Ошибка при назначении исполнителя')
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const onResetSelection = () => {                                 // отменить выбор (чекбоксов и оператора)
    clearSelectedAppeals()
    setSelectedOperator('0')
    // localStorage.removeItem('selectedAppealsWithOperator')        // Очистить Local Storage
  }


  return (
    <div style={{ display: 'flex', gap: 10, marginBottom: 15 }}>
      <FormControl style={{ width: '20%' }}>
        <NativeSelect value={selectedOperator} onChange={handleOperatorChange}>
          <option value="0">Выберите оператора</option>
           {listSubUsers.map(({ ID, LAST_NAME }) => (
            <option key={ID} value={ID}>
              {LAST_NAME}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
      <Button variant="contained" onClick={onAppoint}>
        {isLoading ? 'Назначаем...' : 'Назначить исполнителя'}
      </Button>
      <Button variant="contained" onClick={onResetSelection}>
        Отменить выбор
      </Button>
    </div>
  );
};


export default MultipleChoice